
//Libraries
import { defineComponent } from "vue";

//Components
import Modal from "./core/components/Modal.vue";

export default defineComponent({
  components: {
    Modal,
  },
  setup() {
    //Lifecycle Hooks
  },
});
